import { Typography } from '@mui/joy'

export function Header() {
  return (
    <Typography level="h2" component="h1">
      Embedded Lending Demo Platform
    </Typography>
  )
}
